/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function(){

  $('.cs-slider').slick({
  slidesToShow: 4,
  infinite:false,
  prevArrow: '<button type="button" class="slick-prev"><svg width="14" height="23" viewBox="0 0 19 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7722 14.61L4.591 0.506316C4.28613 0.179852 3.87916 0 3.44522 0C3.01128 0 2.60431 0.179852 2.29944 0.506316L1.32874 1.54472C0.69709 2.22135 0.69709 3.32107 1.32874 3.99668L12.3973 15.8401L1.31645 27.6967C1.01159 28.0231 0.843262 28.4583 0.843262 28.9224C0.843262 29.3869 1.01159 29.8221 1.31645 30.1489L2.28716 31.187C2.59227 31.5135 2.999 31.6933 3.43294 31.6933C3.86688 31.6933 4.27385 31.5135 4.57871 31.187L17.7722 17.0705C18.0778 16.743 18.2457 16.3057 18.2447 15.8409C18.2457 15.3742 18.0778 14.9372 17.7722 14.61Z" fill="black"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="14" height="23" viewBox="0 0 19 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7722 14.61L4.591 0.506316C4.28613 0.179852 3.87916 0 3.44522 0C3.01128 0 2.60431 0.179852 2.29944 0.506316L1.32874 1.54472C0.69709 2.22135 0.69709 3.32107 1.32874 3.99668L12.3973 15.8401L1.31645 27.6967C1.01159 28.0231 0.843262 28.4583 0.843262 28.9224C0.843262 29.3869 1.01159 29.8221 1.31645 30.1489L2.28716 31.187C2.59227 31.5135 2.999 31.6933 3.43294 31.6933C3.86688 31.6933 4.27385 31.5135 4.57871 31.187L17.7722 17.0705C18.0778 16.743 18.2457 16.3057 18.2447 15.8409C18.2457 15.3742 18.0778 14.9372 17.7722 14.61Z" fill="black"/></svg></button>',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 2        
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: false,
        infinite: true,
        centerMode: true,
        centerPadding:'50px'
      }
    },
  ]
  });

    $('.ssw_slider').slick({
    slidesToShow: 1,
    infinite:false,
    arrows: false,
    dots: true,
    prevArrow: '<button type="button" class="slick-prev"><svg width="14" height="23" viewBox="0 0 19 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7722 14.61L4.591 0.506316C4.28613 0.179852 3.87916 0 3.44522 0C3.01128 0 2.60431 0.179852 2.29944 0.506316L1.32874 1.54472C0.69709 2.22135 0.69709 3.32107 1.32874 3.99668L12.3973 15.8401L1.31645 27.6967C1.01159 28.0231 0.843262 28.4583 0.843262 28.9224C0.843262 29.3869 1.01159 29.8221 1.31645 30.1489L2.28716 31.187C2.59227 31.5135 2.999 31.6933 3.43294 31.6933C3.86688 31.6933 4.27385 31.5135 4.57871 31.187L17.7722 17.0705C18.0778 16.743 18.2457 16.3057 18.2447 15.8409C18.2457 15.3742 18.0778 14.9372 17.7722 14.61Z" fill="black"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="14" height="23" viewBox="0 0 19 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.7722 14.61L4.591 0.506316C4.28613 0.179852 3.87916 0 3.44522 0C3.01128 0 2.60431 0.179852 2.29944 0.506316L1.32874 1.54472C0.69709 2.22135 0.69709 3.32107 1.32874 3.99668L12.3973 15.8401L1.31645 27.6967C1.01159 28.0231 0.843262 28.4583 0.843262 28.9224C0.843262 29.3869 1.01159 29.8221 1.31645 30.1489L2.28716 31.187C2.59227 31.5135 2.999 31.6933 3.43294 31.6933C3.86688 31.6933 4.27385 31.5135 4.57871 31.187L17.7722 17.0705C18.0778 16.743 18.2457 16.3057 18.2447 15.8409C18.2457 15.3742 18.0778 14.9372 17.7722 14.61Z" fill="black"/></svg></button>'
  });

  $('.meta-accordian-title').click(function(){
   $(this).toggleClass('active');
   $(this).next('.meta-accordian_content').slideToggle();
  });

  $("body").on("click", ".meta-offer-code", function () {
    var copy_text = $(this);
    var text = $(this).attr('code');
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  // PRODUCT TAB
   $('body').on('click','.pro-tab-btn', function(){
    $(this).addClass('active').siblings().removeClass('active');
    var tabId = $(this).attr('data-head');
    $(this).closest('.pro-tab-tab-container').find('.product-tab-tab-content').children('.pro-tab-text-div').map(function(){
      var textId = $(this).attr('data-text')
      if(tabId == textId) {
          $(this).addClass('show');
        }else{
          $(this).removeClass('show');
        }
    })
  })
  
});

/**
 * Auto-switch Color when the selected Size makes the current Color unavailable.
 * Size-only products are left alone. Works on PDP, sticky ATC, and quick view
 * (drawer + mobile popover) via the bubbled variant:changed event.
 */
(function () {
  function optionNames(product) {
    return (product.options || []).map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
  }

  function hasColorOption(product) {
    return optionNames(product).some(function (name) {
      return /^(color|colour)$/i.test(String(name).trim());
    });
  }

  function sizeOptionIndex(product) {
    return optionNames(product).findIndex(function (name) {
      return /^size$/i.test(String(name).trim());
    });
  }

  function firstAvailableForSelectedSize(product, sizeValue, sizeIdx) {
    if (!product || sizeIdx < 0 || !sizeValue) return null;
    return product.variants.find(function (variant) {
      return variant.available && variant.options[sizeIdx] === sizeValue;
    }) || null;
  }

  function maybeAutoSwitchColor(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var formId = form.getAttribute('id');
    if (!formId) return;

    // Prefer the main PDP picker; fall back to sticky / quick view
    var picker =
      document.querySelector('product-variants.product-form__variants[form-id="' + formId + '"]') ||
      document.querySelector('product-variants[form-id="' + formId + '"]');

    if (!picker || !picker.product) return;
    if (!hasColorOption(picker.product)) return;

    var current = event.detail && event.detail.variant;
    if (!current || current.available) return;

    var sizeIdx = sizeOptionIndex(picker.product);
    var sizeValue = current.options && current.options[sizeIdx];
    var next = firstAvailableForSelectedSize(picker.product, sizeValue, sizeIdx);

    if (next && next.id !== current.id) {
      picker.selectVariant(next.id);
    }
  }

  document.addEventListener('variant:changed', maybeAutoSwitchColor);
})();
